import { theme } from '../tokens/js/theme';
import { darkTheme } from '../tokens/js/darkTheme';
export const getPrefixedThemeColor = (color) => {
    const cleanColor = color.replace('darkTheme.', '');
    const darkThemeColor = color.startsWith('darkTheme.') ? darkTheme.color[cleanColor] : undefined;
    return darkThemeColor ?? theme.color[cleanColor];
};
export const getPrefixedThemeFont = (font) => {
    const cleanFont = font.replace('darkTheme.', '');
    const darkThemeFont = font.startsWith('darkTheme.') ? darkTheme.font[cleanFont] : undefined;
    return darkThemeFont ?? theme.font[cleanFont];
};
